import 'es6-promise/auto'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import store from './store'
import './filter'
import getI18nMessages from './data/i18n-message'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueApexCharts from 'vue-apexcharts'

import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

import CKEditor from '@ckeditor/ckeditor5-vue'

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('apexchart', VueApexCharts)

Vue.use(VCalendar)

Vue.config.productionTip = false
Vue.filter()
Vue.use(VueI18n)

Vue.use(CKEditor)

const i18nMessages = getI18nMessages('en')

const i18n = new VueI18n({
  locale: 'en',
  messages: i18nMessages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js